import './style.scss'

const prefixCls = 'sl-tag';

const initColor = ['default','success','error','warning','processing'];

const Tag = {
  name:'Tag',
  props:['color'],
  computed:{
    classes(){
      const { color } = this
      const cls = [`${prefixCls}`]
      if(color && initColor.includes(color)){
        cls.push(`${prefixCls}-${color}`)
      }else{
        cls.push(`${prefixCls}-color`)
      }
      return cls
    },
    styles(){
      const { color } = this

      if(color && initColor.includes(color)){
        return {

        }
      }else{
        return { borderColor:color, color }
      }
    }
  },
  methods:{

  },
  render(){
    const { $scopedSlots } = this
    return <div class={this.classes} style={this.styles}>{$scopedSlots.default ? $scopedSlots.default() : null}</div>
  }
}

export default Tag